import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Public APIs
export const submitApplication = (email: string) =>
  api.post('/applications', { email });

export const getApplicationStatus = (email: string) =>
  api.get(`/applications/${encodeURIComponent(email)}/status`);

// Admin APIs
export const adminLogin = (username: string, password: string) =>
  api.post('/admin/login', { username, password });

export const getApplications = (params: {
  page?: number;
  size?: number;
  status?: string;
}) => api.get('/admin/applications', { params });

export const approveApplication = (id: number) =>
  api.put(`/admin/applications/${id}/approve`);

export const rejectApplication = (id: number, reason: string) =>
  api.put(`/admin/applications/${id}/reject`, { reason });

export const batchApprove = (ids: number[]) =>
  api.post('/admin/applications/batch-approve', { ids });

export const getInvitations = (params: { page?: number; size?: number }) =>
  api.get('/admin/invitations', { params });

export const getGitHubStatus = () => api.get('/admin/github/status');

export default api;
